export var INVOICE_PAYMENT;
(function (INVOICE_PAYMENT) {
    INVOICE_PAYMENT["ONLINE"] = "ONLINE";
    INVOICE_PAYMENT["INVOICE"] = "INVOICE";
    INVOICE_PAYMENT["BANK_TRANSFER"] = "BANK_TRANSFER";
})(INVOICE_PAYMENT || (INVOICE_PAYMENT = {}));
export const invoicePaymentOptions = Object.freeze({
    [INVOICE_PAYMENT.ONLINE]: {
        id: INVOICE_PAYMENT.ONLINE,
        label: "Online",
    },
    [INVOICE_PAYMENT.INVOICE]: {
        id: INVOICE_PAYMENT.INVOICE,
        label: "Invoice",
    },
    [INVOICE_PAYMENT.BANK_TRANSFER]: {
        id: INVOICE_PAYMENT.BANK_TRANSFER,
        label: "Bank Transfer",
    },
});
export var INVOICE_EXPORT_MAPPING_TYPE;
(function (INVOICE_EXPORT_MAPPING_TYPE) {
    /** One row per line item (single invoice, detailed  view) */
    INVOICE_EXPORT_MAPPING_TYPE["INVOICE_LINE_ITEM"] = "INVOICE_LINE_ITEM";
    /** One row per invoice (aggregated summary view) */
    INVOICE_EXPORT_MAPPING_TYPE["INVOICE_SUMMARY"] = "INVOICE_SUMMARY";
})(INVOICE_EXPORT_MAPPING_TYPE || (INVOICE_EXPORT_MAPPING_TYPE = {}));
export const INVOICE_EXPORT_MAPPING_TYPE_OPTIONS = {
    [INVOICE_EXPORT_MAPPING_TYPE.INVOICE_LINE_ITEM]: {
        id: INVOICE_EXPORT_MAPPING_TYPE.INVOICE_LINE_ITEM,
        label: "Invoice Line Items",
        description: "Each row in the export represents an individual line item of a single invoice. Ideal for inventory tracking, audit trails, and itemized reporting.",
    },
    [INVOICE_EXPORT_MAPPING_TYPE.INVOICE_SUMMARY]: {
        id: INVOICE_EXPORT_MAPPING_TYPE.INVOICE_SUMMARY,
        label: "Invoice Summaries",
        description: "Each row in the export represents a single invoice totals package. Ideal for high-level accounting, revenue overviews, and bulk importing into bookkeeping software.",
    },
};
export var INVOICE_LINE_ITEM_EXPORT_KEY;
(function (INVOICE_LINE_ITEM_EXPORT_KEY) {
    // Line item specifics
    INVOICE_LINE_ITEM_EXPORT_KEY["DESCRIPTION"] = "description";
    INVOICE_LINE_ITEM_EXPORT_KEY["QUANTITY"] = "quantity";
    INVOICE_LINE_ITEM_EXPORT_KEY["PRICE"] = "price";
    INVOICE_LINE_ITEM_EXPORT_KEY["ITEM_ID"] = "itemId";
    INVOICE_LINE_ITEM_EXPORT_KEY["ITEM_CODE"] = "itemCode";
    INVOICE_LINE_ITEM_EXPORT_KEY["TAX_RATE"] = "taxRate";
    INVOICE_LINE_ITEM_EXPORT_KEY["TAX_NAME"] = "taxName";
    INVOICE_LINE_ITEM_EXPORT_KEY["TAX_MODE"] = "taxMode";
    INVOICE_LINE_ITEM_EXPORT_KEY["TAX_AMOUNT"] = "taxAmount";
    INVOICE_LINE_ITEM_EXPORT_KEY["AMOUNT"] = "amount";
    INVOICE_LINE_ITEM_EXPORT_KEY["AMOUNT_BEFORE_TAX"] = "amountBeforeTax";
    INVOICE_LINE_ITEM_EXPORT_KEY["AMOUNT_AFTER_TAX"] = "amountAfterTax";
    // Invoice
    INVOICE_LINE_ITEM_EXPORT_KEY["INVOICE_ID"] = "invoiceId";
    INVOICE_LINE_ITEM_EXPORT_KEY["INVOICE_STATUS"] = "invoiceStatus";
    // Respondent
    INVOICE_LINE_ITEM_EXPORT_KEY["RESPONDENT_ID"] = "respondentId";
    INVOICE_LINE_ITEM_EXPORT_KEY["RESPONDENT_FIRST_NAME"] = "respondentFirstName";
    INVOICE_LINE_ITEM_EXPORT_KEY["RESPONDENT_LAST_NAME"] = "respondentLastName";
    INVOICE_LINE_ITEM_EXPORT_KEY["RESPONDENT_FULL_NAME"] = "respondentFullName";
    // Booking
    INVOICE_LINE_ITEM_EXPORT_KEY["BOOKING_ID"] = "bookingId";
    INVOICE_LINE_ITEM_EXPORT_KEY["BOOKING_DATE"] = "bookingDate";
    // Location
    INVOICE_LINE_ITEM_EXPORT_KEY["LOCATION_ID"] = "locationId";
    INVOICE_LINE_ITEM_EXPORT_KEY["LOCATION_NAME"] = "locationName";
    // Service
    INVOICE_LINE_ITEM_EXPORT_KEY["SERVICE_ID"] = "serviceId";
    INVOICE_LINE_ITEM_EXPORT_KEY["SERVICE_NAME"] = "serviceName";
})(INVOICE_LINE_ITEM_EXPORT_KEY || (INVOICE_LINE_ITEM_EXPORT_KEY = {}));
export var INVOICE_SUMMARY_EXPORT_KEY;
(function (INVOICE_SUMMARY_EXPORT_KEY) {
    // Invoice specifics
    INVOICE_SUMMARY_EXPORT_KEY["ID"] = "id";
    INVOICE_SUMMARY_EXPORT_KEY["ISSUE_DATE"] = "issueDate";
    INVOICE_SUMMARY_EXPORT_KEY["ISSUE_DATE_LOCAL"] = "issueDateLocal";
    INVOICE_SUMMARY_EXPORT_KEY["DUE_DATE"] = "dueDate";
    INVOICE_SUMMARY_EXPORT_KEY["DUE_DATE_LOCAL"] = "dueDateLocal";
    INVOICE_SUMMARY_EXPORT_KEY["INVOICE_NUMBER"] = "invoiceNumber";
    INVOICE_SUMMARY_EXPORT_KEY["REFERENCE"] = "reference";
    INVOICE_SUMMARY_EXPORT_KEY["CURRENCY"] = "currency";
    INVOICE_SUMMARY_EXPORT_KEY["BILLED_AMOUNT"] = "billedAmount";
    INVOICE_SUMMARY_EXPORT_KEY["STATUS"] = "status";
    INVOICE_SUMMARY_EXPORT_KEY["CREATION_SOURCE"] = "creationSource";
    INVOICE_SUMMARY_EXPORT_KEY["CREATION_SOURCE_ID"] = "creationSourceId";
    INVOICE_SUMMARY_EXPORT_KEY["CREATED_AT"] = "createdAt";
    INVOICE_SUMMARY_EXPORT_KEY["UPDATED_AT"] = "updatedAt";
    INVOICE_SUMMARY_EXPORT_KEY["PAYMENT_OPTION"] = "paymentOption";
    INVOICE_SUMMARY_EXPORT_KEY["PURCHASE_ORDER"] = "purchaseOrderNumber";
    // Bill To - Company
    INVOICE_SUMMARY_EXPORT_KEY["BILL_TO_COMPANY_ID"] = "billToCompanyId";
    INVOICE_SUMMARY_EXPORT_KEY["BILL_TO_COMPANY_NAME"] = "billToCompanyName";
    // Bill To - Contact
    INVOICE_SUMMARY_EXPORT_KEY["BILL_TO_CONTACT_ID"] = "billToContactId";
    INVOICE_SUMMARY_EXPORT_KEY["BILL_TO_CONTACT_NAME"] = "billToContactName";
    // Respondent (Only populated if there is a single respondent on the invoice)
    INVOICE_SUMMARY_EXPORT_KEY["RESPONDENT_ID"] = "respondentId";
    INVOICE_SUMMARY_EXPORT_KEY["RESPONDENT_NAME"] = "respondentName";
})(INVOICE_SUMMARY_EXPORT_KEY || (INVOICE_SUMMARY_EXPORT_KEY = {}));
export var INVOICE_DISPLAY_MODE;
(function (INVOICE_DISPLAY_MODE) {
    INVOICE_DISPLAY_MODE["DETAILED"] = "DETAILED";
    INVOICE_DISPLAY_MODE["CONSOLIDATED"] = "CONSOLIDATED";
})(INVOICE_DISPLAY_MODE || (INVOICE_DISPLAY_MODE = {}));
export const invoiceDisplayModeOptions = {
    [INVOICE_DISPLAY_MODE.DETAILED]: {
        id: INVOICE_DISPLAY_MODE.DETAILED,
        label: "Detailed",
        description: "The invoice PDF will contain a detailed list of invoice items",
    },
    [INVOICE_DISPLAY_MODE.CONSOLIDATED]: {
        id: INVOICE_DISPLAY_MODE.CONSOLIDATED,
        label: "Consolidated",
        description: "The invoice PDF will contain a consolidated list of invoice items",
    },
};
export var INVOICE_BACKDATING_STRATEGY;
(function (INVOICE_BACKDATING_STRATEGY) {
    INVOICE_BACKDATING_STRATEGY["LAST_DAY"] = "LAST_DAY";
    INVOICE_BACKDATING_STRATEGY["LAST_BUSINESS_DAY"] = "LAST_BUSINESS_DAY";
    INVOICE_BACKDATING_STRATEGY["LAST_MONDAY"] = "LAST_MONDAY";
    INVOICE_BACKDATING_STRATEGY["LAST_TUESDAY"] = "LAST_TUESDAY";
    INVOICE_BACKDATING_STRATEGY["LAST_WEDNESDAY"] = "LAST_WEDNESDAY";
    INVOICE_BACKDATING_STRATEGY["LAST_THURSDAY"] = "LAST_THURSDAY";
    INVOICE_BACKDATING_STRATEGY["LAST_FRIDAY"] = "LAST_FRIDAY";
    INVOICE_BACKDATING_STRATEGY["LAST_SATURDAY"] = "LAST_SATURDAY";
    INVOICE_BACKDATING_STRATEGY["LAST_SUNDAY"] = "LAST_SUNDAY";
})(INVOICE_BACKDATING_STRATEGY || (INVOICE_BACKDATING_STRATEGY = {}));
export const invoiceBackdatingStrategyOptions = {
    [INVOICE_BACKDATING_STRATEGY.LAST_DAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_DAY,
        label: "Last Day of Previous Month",
    },
    [INVOICE_BACKDATING_STRATEGY.LAST_BUSINESS_DAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_BUSINESS_DAY,
        label: "Last Business Day of Previous Month",
    },
    [INVOICE_BACKDATING_STRATEGY.LAST_MONDAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_MONDAY,
        label: "Last Monday of Previous Month",
    },
    [INVOICE_BACKDATING_STRATEGY.LAST_TUESDAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_TUESDAY,
        label: "Last Tuesday of Previous Month",
    },
    [INVOICE_BACKDATING_STRATEGY.LAST_WEDNESDAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_WEDNESDAY,
        label: "Last Wednesday of Previous Month",
    },
    [INVOICE_BACKDATING_STRATEGY.LAST_THURSDAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_THURSDAY,
        label: "Last Thursday of Previous Month",
    },
    [INVOICE_BACKDATING_STRATEGY.LAST_FRIDAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_FRIDAY,
        label: "Last Friday of Previous Month",
    },
    [INVOICE_BACKDATING_STRATEGY.LAST_SATURDAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_SATURDAY,
        label: "Last Saturday of Previous Month",
    },
    [INVOICE_BACKDATING_STRATEGY.LAST_SUNDAY]: {
        id: INVOICE_BACKDATING_STRATEGY.LAST_SUNDAY,
        label: "Last Sunday of Previous Month",
    },
};
//# sourceMappingURL=invoice.js.map